<template>
  <div>
    <div v-if="!loading" class="pa-2">
      <div v-if="data && data.length">
        <v-card v-for="item in data" :key="item.orderid" class="pa-3 mb-2">
          <v-layout row wrap>
            <v-flex xs6>
              <div style="font-weight: bold">
                <v-chip
                  dense
                  v-for="(linename, k) in item.painter_linename"
                  :key="k"
                  dark
                  :color="statusColor(item.status)"
                  >{{ linename[0] }}</v-chip
                >
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="text-xs-right" :style="{ color: statusColor(item.status) }">
                {{ item.status }}
              </div>
            </v-flex>
            <v-flex xs12>
              <template v-if="item.details">
                <div class="mt-3">
                  สถานที่:
                  {{
                    `${item.details.address1} เขต${item.details.district} แขวง${item.details.sub_district} จังหวัด${item.details.province} เลขไปรษณีย์${item.details.zip_code}`
                  }}
                </div>
                <div>
                  ราคา:
                  {{ item.details.price ? $options.filters.numberFormat(item.details.price) : '-' }}
                </div>
              </template>
            </v-flex>
            <v-flex xs12>
              <v-divider class="mt-3"> </v-divider>
            </v-flex>
            <v-flex xs12>
              <v-layout v-if="item.details" row wrap style="word-break: break-word" class="mb-0">
                <v-flex xs3 v-for="(img, k) in item.details.work_area_images" :key="k" class="pa-1">
                  <a :href="img" target="_blank" rel="noopener noreferrer">
                    <v-img style="height: 80px; object-fit: include" :src="img"></v-img>
                  </a>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div v-else>
        <div class="text-xs-center mt-8">ไม่มีข้อมูล</div>
      </div>
    </div>
    <div v-else class="text-xs-center mt-9" style="margin-top: 40px">
      <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      loading: true,
      data: '',
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    this.getData()
  },
  methods: {
    statusColor(status) {
      if (status == 'งานเสร็จเรียบร้อย') return 'rgb(3 187 0)'
      if (status == 'หาช่าง') return '#23aded'
      if (status == 'ติดต่อช่าง') return '#fcbf44'
    },
    getData() {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        userid: this.value,
      }
      api.toacustomerhistorysearchpainter(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.data = response.data
          if (vm.data && vm.data.length) {
            vm.data = vm.data.map((el) => {
              try {
                return { ...el, details: JSON.parse(el.details) }
              } catch (error) {
                return { ...el, details: {} }
              }
            })
          }
        }
        vm.loading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/livechat/ToaPainterCustomer.vue